import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0A0B0E] border-t border-themed">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-12">
          {/* Brand */}
          <div>
            <h3 className="font-serif text-[#D4AF37] text-xl font-semibold mb-3">{companyInfo.name}</h3>
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#64748B] font-sans mb-4">{companyInfo.tagline}</p>
            <p className="text-sm text-[#94A3B8] font-sans leading-relaxed">
              Professional real estate photo and video editing services trusted by photographers worldwide.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-sans font-semibold mb-5">Navigation</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Featured Work', id: 'featured-work' },
                { label: 'Before & After', id: 'before-after' },
                { label: 'Videos', id: 'video-showcase' },
                { label: 'Services', id: 'services' },
                { label: 'About', id: 'about' },
                { label: 'Contact', id: 'contact' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollTo(item.id)}
                    className="text-sm text-[#94A3B8] hover:text-[#D4AF37] transition-colors duration-300 font-sans cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-sans font-semibold mb-5">Services</h4>
            <ul className="space-y-2.5">
              {['HDR Editing', 'Flambient Editing', 'Virtual Staging', 'Day to Dusk', 'Video Editing', 'Item Removal'].map((name) => (
                <li key={name} className="text-sm text-[#94A3B8] font-sans">{name}</li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-[#D4AF37] font-sans font-semibold mb-5">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Mail size={14} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm text-[#94A3B8] hover:text-[#D4AF37] transition-colors duration-300 font-sans break-all">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone size={14} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-sm text-[#94A3B8] hover:text-[#D4AF37] transition-colors duration-300 font-sans">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin size={14} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <span className="text-sm text-[#94A3B8] font-sans">{companyInfo.location}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-themed mt-12 pt-8 text-center">
          <p className="text-xs text-[#64748B] font-sans">
            &copy; {currentYear} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
